import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { connect } from "react-redux";

import useComparison from "../../utils/validateComparison";

import { setNavigationAssets } from "../../../../store/actions/navigation.action";

import PageLoading from "../../../../components/PageLoading";
import CompareChart from "../../components/CompareChart";
import CompareScores from "../../components/CompareScores/CompareScores";
import ReportsTabbar from "../../components/ReportsTabbar";

import faceHigh from "../../../../assets/images/icons/face_high.svg";
import faceLow from "../../../../assets/images/icons/face_low.svg";
import faceMed from "../../../../assets/images/icons/face_med.svg";

import moment from "moment";
import PageContent from "../../../../components/PageContent";
import PageTitle from "../../../../components/PageTitle";
import { getFaceTransparency } from "../../../../store/helpers/uiHelper";
import Motivator from "../../components/Motivator/Motivator";
import NoSubscription from "../../components/NoSubscription";
import "../../scss/circle.scss";
import { REPORT_TEXTS } from "../../utils/contentTexts";
import "./MoraleCompare.scss";
import DiscussParagraph from "../../../../components/DiscussParagraph";

const DATE_FORMAT = "MMM YYYY";

function MoraleCompare(props) {
  const { setNavigationAssets, comparedQuestionAverages, isFullReport } = props;

  useComparison();

  React.useEffect(() => {
    const navigation = {
      title: "COMPARE AND BENCHMARK",
      subtitle: "MORALE INDEX",
      tab: "COMPARE AND BENCHMARK",
    };
    setNavigationAssets(navigation);
  }, []);

  const texts = REPORT_TEXTS.benchmark.mi;
  let paragraphs = [];
  let restParagraph = [];
  texts.subtitle.filter((text, index) => {
    if (index !== texts.subtitle.length - 1) return paragraphs.push(text);
    else return null;
  });
  restParagraph.push(texts.subtitle[texts.subtitle.length - 1]);
  console.log(texts.subtitle[texts.subtitle.length - 1]);

  return (
    <PageLoading
      render={() => (
        <Fragment>
          <Motivator />
          <PageTitle
            title={texts.title}
            paragraphs={paragraphs}
          >
            {comparedQuestionAverages && (
              <CompareScores
                initialData={{
                  date: comparedQuestionAverages[0].date,
                  average: comparedQuestionAverages[0].mi,
                }}
                lastData={{
                  date: comparedQuestionAverages[1].date,
                  average: comparedQuestionAverages[1].mi,
                }}
                acronym="mi"
              />
            )}
          </PageTitle>
          <PageContent>
            <ReportsTabbar compare={true} />
            {restParagraph.map((text, i) => (
              <h6 key={i} className="mt-4">
                {text}
              </h6>
            ))}
            {isFullReport ? (
              <>
                {comparedQuestionAverages && (
                  <div className="pv-4">
                    <CompareChart
                      data={{
                        title: "Morale Index",
                        subtitle: "mi",
                        initialData: {
                          score: comparedQuestionAverages[0].mi,
                          date: comparedQuestionAverages[0].date,
                        },
                        lastData: {
                          score: comparedQuestionAverages[1].mi,
                          date: comparedQuestionAverages[1].date,
                        },
                      }}
                    />
                  </div>
                )}
                <section className="morale-compare-index">
                  <div className="morale-compare-index__content">
                    <div className="morale-compare-index__content-date">
                      {comparedQuestionAverages &&
                        moment(comparedQuestionAverages[0].date).format(DATE_FORMAT)}
                    </div>
                    {comparedQuestionAverages && (
                      <div className="morale-compare-index__content-faces">
                        <span className="morale-compare-index__content-faces-face">
                          <img
                            className={`${getFaceTransparency(
                              comparedQuestionAverages[0].mi,
                              "low"
                            )}`}
                            src={faceLow}
                            alt="morale-low"
                          />
                        </span>
                        <span className="morale-compare-index__content-faces-face">
                          <img
                            className={`${getFaceTransparency(
                              comparedQuestionAverages[0].mi,
                              "med"
                            )}`}
                            src={faceMed}
                            alt="morale-med"
                          />
                        </span>
                        <span className="morale-compare-index__content-faces-face">
                          <img
                            className={`${getFaceTransparency(
                              comparedQuestionAverages[0].mi,
                              "high"
                            )}`}
                            src={faceHigh}
                            alt="morale-high"
                          />
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="morale-compare-index__content">
                    <div className="morale-compare-index__content-date">
                      {comparedQuestionAverages &&
                        moment(comparedQuestionAverages[1].date).format(DATE_FORMAT)}
                    </div>
                    {comparedQuestionAverages && (
                      <div className="morale-compare-index__content-faces">
                        <span className="morale-compare-index__content-faces-face">
                          <img
                            className={`${getFaceTransparency(
                              comparedQuestionAverages[1].mi,
                              "low"
                            )}`}
                            src={faceLow}
                            alt="morale-low"
                          />
                        </span>
                        <span className="morale-compare-index__content-faces-face">
                          <img
                            className={`${getFaceTransparency(
                              comparedQuestionAverages[1].mi,
                              "med"
                            )}`}
                            src={faceMed}
                            alt="morale-med"
                          />
                        </span>
                        <span className="morale-compare-index__content-faces-face">
                          <img
                            className={`${getFaceTransparency(
                              comparedQuestionAverages[1].mi,
                              "high"
                            )}`}
                            src={faceHigh}
                            alt="morale-high"
                          />
                        </span>
                      </div>
                    )}
                  </div>
                </section>
                <DiscussParagraph />
              </>
            ) : (
              <NoSubscription reportType="Morale Indicator" />
            )}
          </PageContent>
        </Fragment>
      )}
    />
  );
}

MoraleCompare.propTypes = {
  setNavigationAssets: PropTypes.func,
  comparedQuestionAverages: PropTypes.array,
  isTeam360: PropTypes.bool,
  isFullReport: PropTypes.bool,
};

const mapStateToProps = ({ benchmarking, reports }) => {
  return {
    comparedQuestionAverages: benchmarking.comparedQuestionAverages,
    isFullReport: reports && reports.reportStatus && reports.reportStatus.is_full_report,
    isTeam360: reports && reports.reportStatus && reports.reportStatus.is_team_360,
  };
};

export default connect(mapStateToProps, {
  setNavigationAssets,
})(MoraleCompare);
